import View from './view';

export default View.extend( {
    
    template: 'jst/comment.view',

    className: 'comment--wrapper',
    
    serialize() {
        if (!this.model) return undefined;
        
        const { comment, ...ctx } = this.model.toJSON();
        return {
            ...ctx,
            comment: comment.replace( /<(\/?[\-_:a-zA-Z0-9]+)>/g, '&lt;$1&gt;' )
        }
    } 
    
} );


// WEBPACK FOOTER //
// ./src/js/view/comment.js